import { UPDATE_AUTHORIZATIONS_FAILURE, RESEND_WELCOME_EMAIL_FAILURE, RESEND_WELCOME_EMAIL_SUCCESS } from '../store/types/authorizationTypes';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { postCommunicationInfo, updateAuthorizationSummary, updateCommunicationInfo, resendWelcomeEmail } from '../store/actions/authorizations.actions';
import { showToast } from 'modules/layout/layout.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useState } from 'react';
import { postRenderAuthorizationEmailTemplate } from 'modules/emailTemplates/store/emailTemplate.actions';
import AuthServiceEmailComponents from 'modules/emailTemplates/authEmailTemplates/authServiceEmail.components';
import { EMAIL_TEMPLATE_STATUS_IDS } from 'modules/enumerations/enumerationIds';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';
import { Button } from '@mui/material';
import WebAccessDialog from './resendWelcomeEmailModal.component';
import { TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';

const CommunicationCard = props => {
  const [isLoading, setIsLoading] = useState(false);

  const {
    clientInfo,
    authorizationDetails,
    preferredContactTypesEnum,
    authCommentServiceEnum,
    authServices,
    familyMembers,
    authCommentRegardingEnum,
    id,
    emailTemplates,
    vendors,
    primaryContact
  } = props;

  const communicationTabs = [{ header: 'Communication', order: 1, iconPath: ['fas', 'phone'] }];
  const [openWebAccessDialog, setOpenWebAccessDialog] = useState(false);

  let communicationDetails = {
    primaryContactName: primaryContact ? `${primaryContact.firstName} ${primaryContact.lastName}` : '',
    // The API returns a family member's typed emails/phones (personal/work, mobile/home/work), not primary* keys.
    primaryContactEmail: primaryContact ? (primaryContact.primaryEmailAddress || primaryContact.personalEmailAddress || primaryContact.workEmailAddress || '') : '',
    primaryContactPhone: primaryContact ? (primaryContact.primaryPhoneNumber || primaryContact.mobilePhoneNumber || primaryContact.homePhoneNumber || primaryContact.workPhoneNumber || '') : '',
    preferredContactTypeId: authorizationDetails ? authorizationDetails.preferredContactTypeId : '',
    webAccessMobileNumber: authorizationDetails ? authorizationDetails.webAccessMobileNumber : '',
    webAccessEmailAddress: authorizationDetails ? authorizationDetails.webAccessEmailAddress : ''
  }

  const activeServiceTypeIdSet = new Set((authServices || []).map(service => service.authorizationFileServiceTypeId?.toLowerCase()));

  const isCommentServiceAvailable = service => {
    if (!service?.id) {
      return false;
    }

    // HomeSale
    if (service.id === 'f81b6b37-52b0-4903-9203-6fd184192054') {
      return activeServiceTypeIdSet.has('7b17cb15-a7d3-4b23-931a-ded0d4cf54a5');
    }

    // Global
    if (service.id === '7d4d3d04-66b8-4d44-9131-5c7b2cf8b1f6') {
      return activeServiceTypeIdSet.has('e5c3355e-9171-4968-a142-1a9d643a4b7d');
    }

    // Destination Rent/Buy (either renter or buyer destination service)
    if (service.id === '946f7f77-2a35-4d86-9b18-616f927f7124') {
      return (
        activeServiceTypeIdSet.has('1f0148df-2898-4d52-88f1-03f8ceafb74f') ||
        activeServiceTypeIdSet.has('007e4298-676f-4e50-8791-fa6464cd5358')
      );
    }

    // Temp Living
    if (service.id === 'c8aabef5-9434-4e8e-8a6b-4417747ecbed') {
      return activeServiceTypeIdSet.has('a6431f21-754e-4546-8511-12e74170f139');
    }

    // Candidate/Intern
    if (service.id === 'a2ac4e46-bfd3-4656-8f52-e8d0d2aef2dc') {
      return activeServiceTypeIdSet.has('3458d47e-95fd-4d57-b5f1-29e720c74d4f');
    }

    // HHG
    if (service.id === 'e8d4399d-b059-4fcb-9959-fc64c4bb25f3') {
      return activeServiceTypeIdSet.has('cce24947-254f-431a-97a9-2a1469161b8a');
    }

    // Services like Fees/Banking and any unmapped options remain available.
    return true;
  };

  const preferredContactTypes =
    preferredContactTypesEnum && preferredContactTypesEnum.length > 0
      ? preferredContactTypesEnum.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const authCommentServiceTypes =
    authCommentServiceEnum && authCommentServiceEnum.length > 0
      ? authCommentServiceEnum.filter(s => s.isActive === true && isCommentServiceAvailable(s))
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const authCommentRegardingTypes =
    authCommentRegardingEnum && authCommentRegardingEnum.length > 0
      ? authCommentRegardingEnum.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  // const surveyStatusOptions = ['Active', 'On Hold'];
  // const surveyTypeOptions = [
  //   'BVO',
  //   'GBO',
  //   'MLSUM',
  //   'Renter',
  //   'Candidate',
  //   'Lump Sum',
  //   'Global',
  //   'Property Management',
  //   'Southwire Intern',
  //   'Sandia Intern'
  // ];

  const communicationSummaries = [
    {
      header: 'Primary Contact',
      accessorKey: 'primaryContactName',
      type: 'text',
      required: false,
      disabled: true,
      value: communicationDetails ? communicationDetails.primaryContactName : '',
      tab: 1
    },
    {
      header: 'Primary Number',
      accessorKey: 'primaryContactPhone',
      type: 'text',
      required: false,
      disabled: true,
      value: communicationDetails ? communicationDetails.primaryContactPhone : '',
      tab: 1
    },
    {
      header: 'Primary Email',
      accessorKey: 'primaryContactEmail',
      type: 'text',
      required: false,
      disabled: true,
      value: communicationDetails ? communicationDetails.primaryContactEmail : '',
      tab: 1
    },
    {
      header: 'Preferred Contact',
      accessorKey: 'preferredContactTypeId',
      type: 'dropdown-v2',
      required: true,
      options: preferredContactTypes,
      value: communicationDetails ? communicationDetails.preferredContactTypeId : '',
      tab: 1
    },
    {
      dividerLine: true,
      tab: 1
    },
    {
      header: 'Web Access Number',
      accessorKey: 'webAccessMobileNumber',
      type: 'text',
      required: false,
      value: communicationDetails ? communicationDetails.webAccessMobileNumber : '',
      tab: 1
    },
    {
      header: 'Web Access Email',
      accessorKey: 'webAccessEmailAddress',
      type: 'text',
      required: false,
      value: communicationDetails ? communicationDetails.webAccessEmailAddress : '',
      tab: 1
    },
    // {
    //   header: 'Survey Type',
    //   accessorKey: 'surveyType',
    //   type: 'dropdown',
    //   options: surveyTypeOptions,
    //   required: false,
    //   value: authorizationDetails ? authorizationDetails.surveyType ?? surveyTypeOptions[0] : '',
    //   tab: 1
    // },
    // {
    //   header: 'Survey Status',
    //   accessorKey: 'surveyStatus',
    //   type: 'dropdown',
    //   options: surveyStatusOptions,
    //   required: false,
    //   value: authorizationDetails ? authorizationDetails.surveyStatus : '',
    //   hideInModel: true,
    //   tab: 1
    // }
  ];

  const topLink = clientInfo ? { title: clientInfo.description, link: `/clients/${clientInfo.moveTrackClientId}` } : null;

  const updateFields = async (tab, values) => {
    setIsLoading(true);

    let newVals = { ...authorizationDetails };
    newVals.preferredContactTypeId = values.preferredContactTypeId;
    newVals.webAccessMobileNumber = values.webAccessMobileNumber;
    newVals.webAccessEmailAddress = values.webAccessEmailAddress;

    const resp = await props.updateAuthorizationSummary(newVals);
    if (resp.type === UPDATE_AUTHORIZATIONS_FAILURE) {
      props.showToast('Failed to update the auth summary info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      setIsLoading(false);
      return true;
    }
  };

  const resendRelosourceInvite = async (noMobileNumber, diffEmail, diffMobile) => {
    if (authorizationDetails) {

      if (diffEmail !== authorizationDetails.webAccessEmailAddress || diffMobile !== authorizationDetails.webAccessMobileNumber) {
        let newRecord = { ...authorizationDetails };
        newRecord.webAccessEmailAddress = diffEmail && diffEmail.length > 0 && diffEmail !== authorizationDetails.webAccessEmailAddress ? diffEmail : authorizationDetails.webAccessEmailAddress;
        newRecord.webAccessMobileNumber = diffMobile && diffMobile.length > 0 && diffMobile !== authorizationDetails.webAccessMobileNumber ? diffMobile : authorizationDetails.webAccessMobileNumber;

        const updateResponse = await props.updateAuthorizationSummary(newRecord);
        if (updateResponse.type === UPDATE_AUTHORIZATIONS_FAILURE) {
          props.showToast('Failed to save data, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        } else {
          const resp = await props.resendWelcomeEmail(authorizationDetails.fileId, !noMobileNumber);
          if (resp.type === RESEND_WELCOME_EMAIL_SUCCESS) {
            props.showToast(`Successfully resent web access invite for authorization: ${authorizationDetails.fileNumber}`, { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
          } else if (resp.type === RESEND_WELCOME_EMAIL_FAILURE) {
            props.showToast(`Failed to resend web access invite for authorization: ${authorizationDetails.fileNumber}`, { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          }
        }
      } else {
        const resp = await props.resendWelcomeEmail(authorizationDetails.fileId, !noMobileNumber);
        if (resp.type === RESEND_WELCOME_EMAIL_SUCCESS) {
          props.showToast(`Successfully resent web access invite for authorization: ${authorizationDetails.fileNumber}`, { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
        } else if (resp.type === RESEND_WELCOME_EMAIL_FAILURE) {
          props.showToast(`Failed to resend web access invite for authorization: ${authorizationDetails.fileNumber}`, { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        }
      }
    }

  };

  const templates =
    emailTemplates && emailTemplates.length > 0
      ? emailTemplates.filter(s => isIdEqual(s.versionStatusId, EMAIL_TEMPLATE_STATUS_IDS.ACTIVE))
      : [];

  const SendEeEmailButton = () => {
    return (
      <div>
        <Button
          color="secondary"
          variant="contained"
          sx={{ maxHeight: '40px', marginTop: '8px' }}
          onClick={() => setOpenWebAccessDialog(true)}
        >
          Resend RS Invite
        </Button>
        <AuthServiceEmailComponents
          id={id}
          communication={authorizationDetails}
          familyMembers={familyMembers}
          emailTemplates={templates}
          authCommentServicesEnum={authCommentServiceTypes}
          authCommentRegardingEnum={authCommentRegardingTypes}
          showFilterWidgets={true}
          allVendorOptions={vendors}
        />
      </div>

    );
  };

  return (
    <div>
      <EditableCard
        tabs={communicationTabs}
        summaries={communicationSummaries}
        numColumns={2}
        updateFields={updateFields}
        isLoading={isLoading}
        ButtonComponent={props.hideEdit ? null : SendEeEmailButton}
        topLink={topLink}
        hideEdit={Boolean(props.hideEdit)}
      />
      {openWebAccessDialog && (
        <WebAccessDialog
          open={openWebAccessDialog}
          record={authorizationDetails}
          onCancel={() => setOpenWebAccessDialog(false)}
          onSubmit={async (noMobileNumber, primaryEmail, mobileNumber) => await resendRelosourceInvite(noMobileNumber, primaryEmail, mobileNumber)}
        />
      )}
    </div>
  );
};

const mapStateToProps = state => {
  const { preferredContactTypes, authCommentRegarding, authCommentService } = state.enumerations.allEnums;

  return {
    preferredContactTypesEnum: preferredContactTypes,
    authCommentRegardingEnum: authCommentRegarding,
    authCommentServiceEnum: authCommentService
  };
};

export default compose(
  connect(mapStateToProps, {
    postCommunicationInfo,
    updateCommunicationInfo,
    showToast,
    postRenderAuthorizationEmailTemplate,
    updateAuthorizationSummary,
    resendWelcomeEmail
  })
)(CommunicationCard);
